import { CurrentClientIntakeResponsePathParams } from '../clientIntakeResponses.firebase.repo';
import { ClientIntakeResponse } from './clientIntakeResponses.firebase.models';

export class SetCurrentClientIntakeResponseConnection {
	static readonly type =
		'[Current Client Intake Response] Set current client intake response connection';
	constructor(
		public connect: boolean,
		public pathParams: CurrentClientIntakeResponsePathParams,
	) {}
}

export class ClearCurrentClientIntakeResponseConnection {
	static readonly type =
		'[Current Client Intake Response] Clear current client intake response connection';
}

export class SetCurrentClientIntakeResponse {
	static readonly type =
		'[Current Client Intake Response] Set current client intake response';
	constructor(
		public currentClientIntakeResponse: ClientIntakeResponse | null,
	) {}
}
